// Utils
import { prop, propIn } from '../utils/immutableHelper';
import { getName } from './userHelper';

// Types
import { MNUserLike } from './userModelTypes';

export const isSubscribed = (user: MNUserLike): boolean | undefined => propIn(['subscription', 'active'], user);

export const getDisplayName = (user: MNUserLike): string => getName(user);

export const getLastAccessDate = (user: MNUserLike): number | undefined => prop('lastAccessDate', user);
